export { default as BadgeAndIncrementor } from './badge-and-incrementor';
